import tw, { TwStyle, styled } from 'twin.macro';
import { keyframes } from 'styled-components';

type LoaderProps = {
  size: 'xs' | 'sm' | 'md' | 'lg';
  theme: 'light' | 'dark';
  css?: TwStyle;
};

const anim = keyframes`
  from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
  }
`;

const sizes = {
  xs: tw`w-3 h-3 border`,
  sm: tw`w-5 h-5 border-2`,
  md: tw`w-10 h-10 border-4`,
  lg: tw`w-16 h-16 border-[4px]`,
};

const themes = {
  light: tw`border-accent-2 border-b-transparent!`,
  dark: tw`border-accent-2 border-b-transparent!`,
};

const LoadingSpinner = styled.div.attrs({ className: 'loading-spinner' })`
  ${tw`w-8 h-8 rounded-full border-solid m-auto`}
  animation: ${anim} 500ms infinite linear;
`;

export const Loader = ({ size, theme = 'dark', css, ...rest }: LoaderProps): JSX.Element => (
  <LoadingSpinner css={[sizes[size], themes[theme], css]} {...rest} />
);
